var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-actions',[_c('div',{staticClass:"form-inline ml-auto",attrs:{"slot":"context-actions"},slot:"context-actions"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{ name: 'barcode_range_create' },"tag":"button"}},[_vm._v(_vm._s(_vm._f("t")('routes_barcode_ranges_create')))])],1),_vm._v(" Create ")])
}
var staticRenderFns = []

export { render, staticRenderFns }